import { render, staticRenderFns } from "./BrandPagination.vue?vue&type=template&id=5f986b28&scoped=true&"
import script from "./BrandPagination.vue?vue&type=script&lang=js&"
export * from "./BrandPagination.vue?vue&type=script&lang=js&"
import style0 from "./BrandPagination.vue?vue&type=style&index=0&id=5f986b28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f986b28",
  null
  
)

export default component.exports